// extracted by mini-css-extract-plugin
export default {"certi_scroll":"Dashboard_certi_scroll__R3uvV","certi_card":"Dashboard_certi_card__OZXp7"};